/** Access token stays in memory only (XSS mitigation). */
let accessToken: string | null = null;

const REFRESH_KEY = 'tln_refresh_token';
const USER_KEY = 'tln_user';

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function getRefreshToken(): string | null {
  try {
    return sessionStorage.getItem(REFRESH_KEY);
  } catch {
    return null;
  }
}

export function setRefreshToken(token: string | null): void {
  try {
    if (token) sessionStorage.setItem(REFRESH_KEY, token);
    else sessionStorage.removeItem(REFRESH_KEY);
  } catch {
    /* ignore */
  }
}

export function getStoredUserJson(): string | null {
  try {
    return sessionStorage.getItem(USER_KEY);
  } catch {
    return null;
  }
}

export function setStoredUserJson(json: string | null): void {
  try {
    if (json) sessionStorage.setItem(USER_KEY, json);
    else sessionStorage.removeItem(USER_KEY);
  } catch {
    /* ignore */
  }
}

export function clearTokens(): void {
  accessToken = null;
  setRefreshToken(null);
  setStoredUserJson(null);
}
